<div *ngIf="field.showField !== false" class="multi-dropdown-container">
  <div *ngFor="let dropdownValue of dropdownValues; let i = index; trackBy: trackByRowIndex" class="dropdown-row">
    <div *ngIf="!isMultiselect" class="flex-container">
      <div class="input-field-wrapper">
        <span class="p-float-label">
          <!-- Single Select Dropdown -->
          <p-dropdown 
            #dropdown
            [(ngModel)]="dropdownValues[i]" 
            (ngModelChange)="onDropdownChange(i, $event)"
            [options]="getAvailableOptions(i)" 
            [optionLabel]="field.optionLabel" 
            [optionValue]="field.optionValue"
            [filter]="field.filter" 
            [filterBy]="field.filterBy"
            [scrollHeight]="field.scrollHeight || '200px'" 
            [showClear]="field.showClear"
            [disabled]="field.disabled"
            [placeholder]="'Select ' + getDropdownLabel(i)"
            [ngStyle]="{'width': '100%'}">
            
            <ng-template let-option pTemplate="selectedItem">
              <div *ngIf="option">
                <span *ngIf="option.id">({{ option.id }})</span>
                <span *ngIf="option[field.optionLabel || 'name']">
                  <strong> {{ option[field.optionLabel || 'name'] }} </strong>
                </span>
                <span *ngIf="option[field.optionSubLabel]"> - {{ option[field.optionSubLabel] }}</span>
                <span *ngIf="option.path"> - {{ option.path }}</span>
              </div>
            </ng-template>
            
            <ng-template let-option pTemplate="item">
              <div>
                <span *ngIf="option.id">({{ option.id }})</span>
                <span *ngIf="option[field.optionLabel || 'name']">
                  <strong> {{ option[field.optionLabel || 'name'] }} </strong>
                </span>
                <span *ngIf="option[field.optionSubLabel]"> - {{ option[field.optionSubLabel] }}</span>
                <span *ngIf="option.path"> - {{ option.path }}</span>
              </div>
            </ng-template>
          </p-dropdown>
          <label>{{ getDropdownLabel(i) }}</label>
        </span>
      </div>
    </div>
    
    <div *ngIf="isMultiselect" class="flex-container">
      <div class="input-field-wrapper">
        <span class="p-float-label">
          <!-- Multi Select Dropdown -->
          <p-multiSelect 
            #multiSelect
            [(ngModel)]="dropdownValues[i]" 
            (ngModelChange)="onDropdownChange(i, $event)"
            [options]="getAvailableOptions(i)" 
            [optionLabel]="field.optionLabel" 
            [optionValue]="field.optionValue"
            [filter]="field.filter" 
            [filterBy]="field.filterBy"
            [scrollHeight]="field.scrollHeight || '200px'" 
            [showClear]="field.showClear"
            [disabled]="field.disabled"
            [placeholder]="'Select ' + getDropdownLabel(i)"
            [display]="field.multiSelectDisplayType || 'chip'"
            [maxSelectedLabels]="field.maxSelectedLabels ?? 999"
            [selectedItemsLabel]="field.selectedItemsLabel || '{0} items selected'"
            [ngStyle]="{'width': '100%'}">
            <!-- Template for selected items -->
            <ng-template let-option pTemplate="selectedItem">
              <div *ngIf="option">
                <span *ngIf="option.id">({{ option.id }})</span>
                <span *ngIf="option[field.optionLabel || 'name']">
                  <strong> {{ option[field.optionLabel || 'name'] }} </strong>
                </span>
                <span *ngIf="option[field.optionSubLabel]"> - {{ option[field.optionSubLabel] }}</span>
                <span *ngIf="option.path"> - {{ option.path }}</span>
              </div>
            </ng-template>
            
            <!-- Template for items in dropdown -->
            <ng-template let-option pTemplate="item">
              <div>
                <span *ngIf="option.id">({{ option.id }})</span>
                <span *ngIf="option[field.optionLabel || 'name']">
                  <strong> {{ option[field.optionLabel || 'name'] }} </strong>
                </span>
                <span *ngIf="option[field.optionSubLabel]"> - {{ option[field.optionSubLabel] }}</span>
                <span *ngIf="option.path"> - {{ option.path }}</span>
              </div>
            </ng-template>
          </p-multiSelect>
        </span>
      </div>
    </div>
  </div>
  
  <!-- Show message when no dropdowns are available -->
  <div *ngIf="quantity === 0" class="no-dropdowns-message">
    <p class="text-muted">Set the "{{ field.quantityLabel || '# of Bundle Items' }}" value to display dropdown selectors.</p>
  </div>
</div>